import React from "react"
import { ErrorBoundary } from "react-error-boundary"
import "./index.scss"
import { BarChart } from "./BarChart"
import { getPercent, getQuestion } from "./utils"
import Pie from "./PieChart"
import { Actions } from "./Actions"

export const UIChart = ({
  id,
  sort = true,
  pie = false,
  title = true,
  condition,
  source = undefined,
  groupBy = undefined,
  year = 2020,
}) => {
  const { label, results, total } = getQuestion({
    id,
    condition,
    source,
    groupBy,
    year,
  })
  const res = results
    .filter(r => r.label !== "false")
    .map(r => {
      return { ...r, percent: getPercent(r.value, total) }
    })

  let transformedData
  if (label === "What is Your NET salary range per year in USD:") {
    const lessThenOneK = res.find(r => r.label === "< $1,000")
    const tenToFifteenK = res.find(r => r.label === "$10,000 - $15,000")
    
    const oneToTwoK = res.find(r => r.label === "$1,000 - $2,000")
    const fifteenToTwentyK = res.find(r => r.label === "$15,000 - $20,000")
    
    const twoToFiveK = res.find(r => r.label === "$2,000 - $5,000")
    const thirtyToFortyK = res.find(r => r.label === "$30,500 - $40,000")
    
    transformedData = res.filter(r => {
      return ![
        "< $1,000",
        "$1,000 - $2,000",
        "$2,000 - $5,000",
        "$10,000 - $15,000",
        "$15,000 - $20,000",
        "$30,500 - $40,000",
      ].includes(r.label)
    })
    console.log(
      "lessThenOneK, tenToFifteenK, oneToTwoK, fifteenToTwentyK, twoToFiveK, thirtyToFortyK",
      lessThenOneK,
      tenToFifteenK,
      oneToTwoK,
      fifteenToTwentyK,
      twoToFiveK,
      thirtyToFortyK
    )
    
    if (tenToFifteenK || lessThenOneK) {
    transformedData.push({
      ...tenToFifteenK,
      key: "4",
      label: "$10,000 - $15,000",
      value: (tenToFifteenK?.value ?? 0) + (lessThenOneK?.value ?? 0),
      grouped: tenToFifteenK?.grouped || lessThenOneK?.grouped,
      percent: (
        parseFloat(tenToFifteenK?.percent ?? 0) +
        parseFloat(lessThenOneK?.percent ?? 0)
      ).toString(),
    })
  }
  if (fifteenToTwentyK || oneToTwoK) {
    transformedData.push({
      ...fifteenToTwentyK,
      key: "5",
      label: "$15,000 - $20,000",
      value: (fifteenToTwentyK?.value ?? 0) + (oneToTwoK?.value ?? 0),
      grouped: fifteenToTwentyK?.grouped || oneToTwoK?.grouped,
      percent: (
        parseFloat(fifteenToTwentyK?.percent ?? 0) +
        parseFloat(oneToTwoK?.percent ?? 0)
      ).toString(),
    })
  }
    if (thirtyToFortyK || twoToFiveK) {
      transformedData.push({
        ...thirtyToFortyK,
        key: "7",
        label: "$30,500 - $40,000",
        value: (thirtyToFortyK?.value ?? 0) + (twoToFiveK?.value ?? 0),
        grouped: thirtyToFortyK?.grouped || twoToFiveK?.grouped,
        percent: (
          parseFloat(thirtyToFortyK?.percent ?? 0) +
          parseFloat(twoToFiveK?.percent ?? 0)
        ).toString(),
      })
    }
    console.log("results", { transformedData, label, results, total, res })
  } else {
    transformedData = res
  }

  transformedData.sort((b, a) =>
    sort ? (a.value > b.value ? 1 : b.value > a.value ? -1 : 0) : 0
  )

  return (
    <div className="chart" id={id}>
      <h4>{title ? (typeof title === "string" ? title : label) : null}</h4>
      {pie ? (
        <Pie results={transformedData} total={total} />
      ) : (
        <BarChart results={transformedData} total={total} />
      )}
      <Actions id={id} />
    </div>
  )
}

function ErrorFallback({ error }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
    </div>
  )
}

export const Chart = props => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <UIChart {...props} />
    </ErrorBoundary>
  )
}
